import PlayPositions from "@Enums/PlayPositions";
import FieldPositions from "@Enums/SimplifiedPlayPositions";
import { DEFAULT_POSITION_SECTIONS, PositionSelectorConfig } from "@Constants/game/position-config";

type PositionSection = PositionSelectorConfig["sections"][number];

export const getPositionsFromSection = (section: FieldPositions, sections: readonly PositionSection[] = DEFAULT_POSITION_SECTIONS): PlayPositions[] => {
  return [...(sections.find(positionSection => positionSection.id === section)?.positions ?? [])];
};

export const getSectionFromPosition = (position: PlayPositions, sections: readonly PositionSection[] = DEFAULT_POSITION_SECTIONS): FieldPositions => {
  return sections.find(positionSection => positionSection.positions.includes(position))?.id ?? FieldPositions.DEFENSIVE;
};
